import {useGrpcRequestMutation} from '@aboutyou/data-fetcher';
import {CouponService_GetUnlockCouponInfoLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coupons/v1/service.grpc.lazy';
import {useFullSession} from '@aboutyou/user';
import {useCallback} from 'react';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';
import {useEntryUrlCrmCouponTokenParam} from '../../Coupons/useCrmCouponTokenParam';
import {useReductionsStateRequestParameter} from '../../ReductionsState/useReductionsStateRequestParameter';
import {useUnlockCouponInfoRequestIdentifier} from './useUnlockCouponInfoRequestIdentifier';

export const useUnlockCouponInfoCallback = () => {
  const session = useFullSession();
  const reductionsState = useReductionsStateRequestParameter();
  const targetGroup = useTargetGroupIdentifier();
  const identifier = useUnlockCouponInfoRequestIdentifier();

  const couponToken = useEntryUrlCrmCouponTokenParam(); // keeping ref since we dont want to immediately unmount the component when a redirect happens from within the UnlockCoupon datafetcher

  const unlockCouponMutation = useGrpcRequestMutation(
    CouponService_GetUnlockCouponInfoLazy,
  );

  const unlockCouponInfoCallback = useCallback(() => {
    return unlockCouponMutation.mutateAsync({
      session: session!,
      couponToken: couponToken!,
      reductionsState,
      targetGroup,
      identifier,
    });
  }, [
    couponToken,
    identifier,
    reductionsState,
    session,
    targetGroup,
    unlockCouponMutation,
  ]);

  return {
    unlockCouponInfoCallback,
    isCouponUnlocking: unlockCouponMutation.isPending,
  };
};
